import { render, staticRenderFns } from "./widget-select.vue?vue&type=template&id=76646272&scoped=true"
import script from "./widget-select.vue?vue&type=script&lang=js"
export * from "./widget-select.vue?vue&type=script&lang=js"
import style0 from "./widget-select.vue?vue&type=style&index=0&id=76646272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76646272",
  null
  
)

export default component.exports